import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/firebase';
import Router from './Router';
import { Toaster } from 'react-hot-toast';

function App() {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log("FIREBASE CONNECTIVITY TEST:", {
        connected: true,
        user: user ? user.uid : 'No user',
        timestamp: new Date().toISOString()
      });
    });
    return () => unsubscribe();
  }, []);

  return (
    <BrowserRouter>
      <Toaster position="top-center" reverseOrder={false} />
      <Router />
    </BrowserRouter>
  );
}

export default App;
